import React from 'react'
import NotAuthorized from './NotAuthorized'

export default ({ component: Component, hasAccess = true, ...rest }) =>
  hasAccess ? <Component {...rest} /> : <NotAuthorized />
